import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { AreaChartModule } from '@core/components/charts/area/area.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DataVolumetryTableComponent } from './data-volumetry-table.component';

@NgModule({
  entryComponents: [
    DataVolumetryTableComponent
  ],
  imports: [
    FuseSharedModule,
    TranslateModule,
    AreaChartModule,
    MatTableModule,
    MatProgressSpinnerModule,
    NgxSkeletonLoaderModule
  ],
  declarations: [
    DataVolumetryTableComponent
  ],
  exports: [
    DataVolumetryTableComponent
  ]
})
export class DataVolumetryTableModule {}
